(() => {
	let $activeDrawer;
	let isAnimating = false;

	const $toggles = $('[data-toggle-drawer]');

	// Init Toggles
	// ----------------------------------------

	$toggles.each(function () {
		const $toggle = $(this);
		const $drawer = $(`[data-drawer="${$toggle.data('toggle-drawer')}"]`);

		$toggle.on('click', (e) => {
			e.preventDefault();
			toggleDrawer($drawer);
		});
	});

	// Drawer State
	// ----------------------------------------

	async function toggleDrawer($drawer) {
		// Close active drawer
		if ($activeDrawer && $activeDrawer.data('drawer') != $drawer.data('drawer')) {
			await closeDrawer($activeDrawer);
		}

		// Toggle
		if (!$activeDrawer) {
			await openDrawer($drawer);
		} else {
			await closeDrawer($drawer);
		}
	}

	async function openDrawer($drawer) {
		if (isAnimating) return;
		isAnimating = true;

		// Trigger start event
		$drawer.trigger('drawer:will-open', []);

		// Set active state on all toggles
		$(`[data-toggle-drawer="${$drawer.data('drawer')}"]`).addClass('-active');

		// Animate
		await gsap
			.timeline()
			.set($drawer, {
				display: 'block',
				width: $drawer.outerWidth()
			})
			.addLabel('start')
			.to(
				$drawer,
				{
					duration: 0.5,
					ease: 'power2.inOut',
					x: 0
				},
				'start'
			)
			.to(
				'#page-wrap',
				{
					duration: 0.5,
					ease: 'power2.inOut',
					x: () => {
						const width = $drawer.outerWidth();
						return -width;
					}
				},
				'start'
			);

		// Update
		isAnimating = false;
		$activeDrawer = $drawer;
		$BODY.addClass('drawer-open');

		// Trigger end event
		$drawer.trigger('drawer:did-open', []);
	}

	async function closeDrawer($drawer) {
		if (isAnimating) return;
		isAnimating = true;

		// Trigger start event
		$drawer.trigger('drawer:will-close', []);

		// Set active state on all toggles
		$(`[data-toggle-drawer="${$drawer.data('drawer')}"]`).removeClass('-active');

		// Animate
		await gsap
			.timeline()
			.addLabel('start')
			.to(
				$drawer,
				{
					duration: 0.5,
					ease: 'power2.inOut',
					xPercent: 100,
					clearProps: true
				},
				'start'
			)
			.to(
				'#page-wrap',
				{
					duration: 0.5,
					ease: 'power2.inOut',
					x: 0,
					clearProps: true
				},
				'start'
			);

		// Update
		isAnimating = false;
		$activeDrawer = null;
		$BODY.removeClass('drawer-open');

		// Trigger end event
		$drawer.trigger('drawer:did-close', []);
	}

	// Events
	// ----------------------------------------

	$WINDOW.on('page:load-started', () => {
		if ($activeDrawer) {
			closeDrawer($activeDrawer);
		}
	});

	$WINDOW.on('resize:horizontal', () => {
		if ($activeDrawer) {
			closeDrawer($activeDrawer);
		}
	});
})();
